var m = require('mithril');
var go = require('gojs');
var edit = require('../../../../layout/components/edit');
var diagramConfiguration = require('../diagramConfiguration');
var editCustomEquipmentModal = require('../../../editCustomEquipmentModal');
var loaders = require('../../../../layout/components/loaders');
var { bindingChannel } = require('../../bindingChannel');
var createExternalConnectionAnnotations = require('./helpers/externalConnectionAnnotations');
var resizableEquipment = require('./helpers/resizableEquipment');

const $ = go.GraphObject.make;  // for more concise visual tree definitions
const portCoverBrush = $(go.Brush, "Linear", { 0: "#2a2a2a", 1: "#f0f0f0", start: go.Spot.Bottom, end: go.Spot.Top });

function damperTemplate(map, useGeoPositioning, submitCallback, diagram) {
  return $(go.Node, "Spot",
    {
      locationSpot: go.Spot.Center,
      resizeObjectName: "BODY",
      resizeCellSize: resizableEquipment.getResizeCellSize(),
      contextMenu: edit.vm.editing() ? $("ContextMenu",
        $("ContextMenuButton",
          $(go.TextBlock, "Edit Equipment"),
          {
            click: (e, obj) => {
              editCustomEquipmentModal.editDialogue({ ...obj.part.data }, { submitCallback: submitCallback, delete: true })
              m.redraw();
            }
          }
        ),
        $("ContextMenuButton",
          $(go.TextBlock, "Copy Bindings"),
          { 
            click: (e, obj) => {
              window.latestBindingData = null;
              // Always copy the current node's bindings:
              window.latestBindingData = {
                originRid: obj.part.data.key
              };
              
              // Persist in localStorage:
              localStorage.setItem("gojsBindingClipboard", JSON.stringify(window.latestBindingData));
              
              // Broadcast the copy event:
              bindingChannel.postMessage({
                type: "copyBinding",
                data: window.latestBindingData
              });
              
              m.redraw();
            }
          }
        ),
        $("ContextMenuButton",
          new go.Binding("visible", "", () => {
            return !window.latestBindingData || Object.keys(window.latestBindingData).length === 0 ? false : true
          }),
          $(go.TextBlock, "Paste Bindings"),
          { 
            click: async (e, obj) => {                  
              let url = `/api/v1/diagram/${obj.part.data.key.slice(1)}/pastebindings`;
              await loaders.requestWithLoader({
                url,
                method: "PUT",
                body: {
                  originRid: window.latestBindingData.originRid,
                }
              })
              .then((response) => {
                return submitCallback();
              })
              .catch((error) => {
                console.error("Error:", error);
              })
              .finally(() => {
                //Clear the clipboard after pasting:
                window.latestBindingData = null;
                localStorage.removeItem("gojsBindingClipboard");
              })
            }
          }
        ),
        $("ContextMenuButton",
          $(go.TextBlock, "Edit Permissions"),
          {
            click: (e, obj) => {
              m.route.set(`/equipment/${obj.part.data['class']}/${obj.part.data['key'].toString().slice(1)}/permissions`)
            }
          }
        )
      ) : null,
      doubleClick: function (e, obj) {
        // Navidate to the equipment detail page in browse mode
        if (!edit.vm.editing()) {
          m.route.set(`/equipment/${obj.part.data['class']}/${obj.part.data['key'].toString().slice(1)}`)
        }
      }
    },
    new go.Binding("cursor", "", data => {
      return edit.vm.editing() ? "pointer" : "default";
    }),
    new go.Binding("deletable", "", data => {
      return edit.vm.editing();
    }),
    new go.Binding("selectable", "", data => {
      return edit.vm.editing();
    }),
    new go.Binding("movable", "", data => {
      return edit.vm.editing();
    }),
    resizableEquipment.createResizableBinding(),
    useGeoPositioning ?
      new go.Binding("location", "latlong", data => {
        const pos = map.project(data, map.getZoom());
        return new go.Point(pos.x, pos.y);
      }).makeTwoWay((pt, data) => {
        if (updatingGoJs) {
          return data.latlong; // no-op
        } else {
          const ll = map.unproject(L.point(pt.x, pt.y), map.getZoom());
          return [ll.lat, ll.lng];
        }
      })
      :
      new go.Binding("location", "latlong", data => {
        const cellHeight = diagramConfiguration.calculateCellHeight();
        const cellWidth = diagramConfiguration.calculateCellWidth();
        return new go.Point(data[0] + cellWidth / 2, data[1] + cellHeight / 2); // Moves down by half a grid cell
        //return new go.Point(data[0], data[1]);
      }),
      $(go.Panel, "Table",
        $(go.Panel, "Spot",
          {
            row: 1, column: 1, name: "BODY",
            alignment: go.Spot.Center
          },
          ...resizableEquipment.createBodySizeBindings(),
          // **Larger Line (Aligned to Grid)**
          $(go.Shape,
            {
              geometryString: "M -35 0 L 35 0",
              stroke: "gray",
              strokeWidth: 8,
              alignment: go.Spot.Center,
            },
            new go.Binding("name", "pointsLinkedData", function (pointsLinkedData){
              let name = `DamperLine_${pointsLinkedData.nodeKey}`;
              return name;
            }),
            new go.Binding("angle", "pointsLinkedData", function(pointsLinkedData) {
              pointsLinkedData.fakeColumns = (pointsLinkedData.pointsLinked || []).map(pointLinked => {
                return {
                  in: {
                    '@rid': pointLinked.rid,
                    minValue: pointsLinkedData.pointsLinkedMinValue,
                    maxValue: pointsLinkedData.pointsLinkedMaxValue,
                    direction: pointsLinkedData.pointLinkeddirection || 'clockwise',
                    equipmentClass: 'Damper',
                    nodeKey: pointsLinkedData.nodeKey, 
                    formula: pointsLinkedData.formula,
                    pointsLinked: pointsLinkedData.pointsLinked,
                    value: '0'
                  }
                }
              });
              pointsLinkedData.fakeColumns.forEach(fakeColumn => {
                if (fakeColumn && fakeColumn.in && fakeColumn.in['@rid']) {
                  if (
                    !diagram.model.modelData[`${pointsLinkedData.nodeKey}_${fakeColumn.in['@rid'].toString()}`] &&
                    diagram.model.modelData[`${pointsLinkedData.nodeKey}_${fakeColumn.in['@rid'].toString()}`] != 0
                  ) {
                    diagram.model.commit(function(mod) {
                      mod.set(mod.modelData, `${pointsLinkedData.nodeKey}_${fakeColumn.in['@rid'].toString()}`, '0');
                    });
                    if(!edit.vm.editing()) {
                      const pointSubscriberObj = diagram && (diagram.pointSubscriber || diagram.pointSubscriberObj);
                      if (pointSubscriberObj) {
                        pointSubscriberObj.subscribe({column: fakeColumn}, diagram);
                      }
                    }
                  }
                }
              })
              return 0;
            })
          ),
          // **Larger Circle (Aligned to Grid)**
          $(go.Shape, "Circle",
            {
              stroke: null,
              fill: "gray",
              width: 15,
              height: 15,
              alignment: go.Spot.Center
            }
          )
        ),
        $(go.Panel, "Vertical",
          new go.Binding("itemArray", "leftArray"),
          {
            row: 1, column: 0,
            itemTemplate:
              $(go.Panel,
                {
                  _side: "left",  // internal property to make it easier to tell which side it's on
                  fromSpot: go.Spot.Left, 
                  toSpot: go.Spot.Left,
                  cursor: "pointer",
                  //contextMenu: portMenu
                },
                new go.Binding("portId", "portId", function(portId) {
                  return portId.split('_')[1]
                }),
                new go.Binding("category", "category"),
                new go.Binding("fromLinkable", "type", function(type) {
                  // Set fromLinkable to true if the node's type is "input"
                  return type === "output";
                }),
                new go.Binding("toLinkable", "type", function(type) {
                  // Set toLinkable to true if the node's type is "output"
                  return type === "input";
                }),
                $(go.Shape, "Rectangle",
                  {
                    stroke: null, strokeWidth: 0,
                    desiredSize: new go.Size(diagramConfiguration.calculateCellWidth(), diagramConfiguration.calculateCellHeight()),
                    margin: new go.Margin(diagramConfiguration.calculateCellHeight() / 2, 0)
                  },
                  new go.Binding("fill", "portColor", function(portColor) {
                    if(!edit.vm.editing()) {
                      return portCoverBrush;
                    } else {
                      return portColor
                    }
                  }))
              )  // end itemTemplate
          }
        ), 
        $(go.Panel, "Horizontal",
          new go.Binding("itemArray", "topArray"),
          {
            row: 0, column: 1,
            itemTemplate:
              $(go.Panel,
                {
                  _side: "top",
                  fromSpot: go.Spot.Top, 
                  toSpot: go.Spot.Top,
                  cursor: "pointer",
                  //contextMenu: portMenu
                },
                new go.Binding("portId", "portId", function(portId) {
                  return portId.split('_')[1]
                }),
                new go.Binding("category", "category"),
                new go.Binding("fromLinkable", "type", function(type) {
                  // Set fromLinkable to true if the node's type is "input"
                  return type === "output";
                }),
                new go.Binding("toLinkable", "type", function(type) {
                  // Set toLinkable to true if the node's type is "output"
                  return type === "input";
                }),
                $(go.Shape, "Rectangle",
                  {
                    stroke: null, strokeWidth: 0,
                    desiredSize: new go.Size(diagramConfiguration.calculateCellWidth(), diagramConfiguration.calculateCellHeight()),
                    margin: new go.Margin(0, diagramConfiguration.calculateCellWidth() / 2)
                  },
                  new go.Binding("fill", "portColor", function(portColor) {
                    if(!edit.vm.editing()) {
                      return portCoverBrush;
                    } else {
                      return portColor
                    }
                  }))
              )  // end itemTemplate
          }
        ),
        $(go.Panel, "Vertical",
          new go.Binding("itemArray", "rightArray"),
          {
            row: 1, column: 2,
            itemTemplate:
              $(go.Panel,
                {
                  _side: "right",
                  fromSpot: go.Spot.Right, 
                  toSpot: go.Spot.Right,
                  cursor: "pointer",
                  //contextMenu: portMenu
                },
                new go.Binding("portId", "portId", function(portId) {
                  return portId.split('_')[1]
                }),
                new go.Binding("category", "category"),
                new go.Binding("fromLinkable", "type", function(type) {
                  // Set fromLinkable to true if the node's type is "input"
                  return type === "output";
                }),
                new go.Binding("toLinkable", "type", function(type) {
                  // Set toLinkable to true if the node's type is "output"
                  return type === "input";
                }),
                $(go.Shape, "Rectangle",
                  {
                    stroke: null, strokeWidth: 0,
                    desiredSize: new go.Size(diagramConfiguration.calculateCellWidth(), diagramConfiguration.calculateCellHeight()),
                    margin: new go.Margin(diagramConfiguration.calculateCellHeight() / 2, 0)
                  },
                  new go.Binding("fill", "portColor", function(portColor) {
                    if(!edit.vm.editing()) {
                      return portCoverBrush;
                    } else {
                      return portColor
                    }
                  }))
              )  // end itemTemplate
          }
        ),
        $(go.Panel, "Horizontal",
          new go.Binding("itemArray", "bottomArray"),
          {
            row: 2, column: 1,
            itemTemplate:
              $(go.Panel,
                {
                  _side: "bottom",
                  fromSpot: go.Spot.Bottom, 
                  toSpot: go.Spot.Bottom,
                  cursor: "pointer",
                  //contextMenu: portMenu
                },
                new go.Binding("portId", "portId", function(portId) {
                  return portId.split('_')[1]
                }),
                new go.Binding("category", "category"),
                new go.Binding("fromLinkable", "type", function(type) {
                  // Set fromLinkable to true if the node's type is "input"
                  return type === "output";
                }),
                new go.Binding("toLinkable", "type", function(type) {
                  // Set toLinkable to true if the node's type is "output"
                  return type === "input";
                }),
                $(go.Shape, "Rectangle",
                  {
                    stroke: null, strokeWidth: 0,
                    desiredSize: new go.Size(diagramConfiguration.calculateCellWidth(), diagramConfiguration.calculateCellHeight()),
                    margin: new go.Margin(0, diagramConfiguration.calculateCellWidth() / 2)
                  },
                  new go.Binding("fill", "portColor", function(portColor) {
                    if(!edit.vm.editing()) {
                      return portCoverBrush;
                    } else {
                      return portColor
                    }
                  }))
              )  // end itemTemplate
          }
        ),
        $(go.Panel, "Horizontal",
          new go.Binding("itemArray", "centerArray"),
          {
            row: 1, column: 1, // Adjust the row and column if needed
            itemTemplate:
              $(go.Panel, // or "Horizontal" depending on your layout
                {
                  alignment: go.Spot.Center,
                  fromSpot: go.Spot.AllSides,
                  toSpot: go.Spot.AllSides,
                  fromLinkable: true,
                  toLinkable: true,
                  fromMaxLinks: 1,
                  toMaxLinks: 1,
                  visible: edit.vm.editing() ? true : false,
                },
                new go.Binding("portId", "portId", function(portId) {
                  return portId.split('_')[1]
                }),
                new go.Binding("category", "category"),
                $(go.Shape, "Rectangle",
                  {
                    stroke: null, strokeWidth: 0,
                    desiredSize: new go.Size(diagramConfiguration.calculateCellWidth(), diagramConfiguration.calculateCellHeight()),
                    margin: new go.Margin(0, diagramConfiguration.calculateCellWidth() / 2),
                  },
                  new go.Binding("fill", "portColor", function(portColor) {
                    if(!edit.vm.editing()) {
                      return portCoverBrush;
                    } else {
                      return portColor
                    }
                  }))
              )
          },
        ),
        createExternalConnectionAnnotations()
      )
  );
}

module.exports = damperTemplate;
